import { render, staticRenderFns } from "./ListExternal.vue?vue&type=template&id=61a47ef0&scoped=true&"
import script from "./ListExternal.vue?vue&type=script&lang=js&"
export * from "./ListExternal.vue?vue&type=script&lang=js&"
import style0 from "./ListExternal.vue?vue&type=style&index=0&id=61a47ef0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a47ef0",
  null
  
)

export default component.exports